import axios from 'axios';
const instance = axios.create({
   // baseURL: 'https://api.maavybooks.com/api/'
   //baseURL: 'http://localhost/thestartupconnect/thestartup/'

   //Online
   //baseURL : 'https://pragatiprathmik.com/api/',

   
    //baseURL: 'https://api.pragatiprathmik.com/api/',

    //baseURL: 'https://lightslategray-dog-143429.hostingersite.com/apidata/public/index.php/api/',

   //Offline
   //baseURL : 'http://127.0.0.1:8000/api/'
   //  baseURL: 'https://pragatiprathmik.businesssamadhan.in/api/',
   baseURL: 'https://api.pragatiprathmik.com/api/',


});
export default instance;